








import {Component, Vue} from "vue-property-decorator";

@Component
export default class Background extends Vue {
    protected get isPlaying(): boolean {
        return this.$store.getters.isPlaying;
    }
}
